import React from 'react'
import classNames from 'classnames'

import FavoriteIcon from '../../../../components/icons/favorite'
import CartIcon from '../../../../components/icons/cart'
import FolderOpenIcon from '../../../../components/icons/folderOpen'

import styles from './itemActions.module.css'

const ItemActions = ({
  item,
  onAddToFavourites,
  onAddToCollections,
  onAddToCart,
  defaultTheme = true,
  // TODO: fix style for item actions so we can get rid of this props
  nonAudioTheme = false,
  transparentTheme = false
}) => {
  const favoriteClassNames = classNames(styles.action, {
    [styles.active]: item.ui.isInFavourites
  })

  const bookmarkClassNames = classNames(styles.action, {
    [styles.active]: item.ui.isInBookmarks
  })

  const cartClassNames = classNames(styles.action, {
    [styles.active]: item.ui.isInCart
  })

  const rootClassName = classNames({
    [styles.defaultTheme]: defaultTheme,
    [styles.nonAudioTheme]: nonAudioTheme,
    [styles.transparentTheme]: transparentTheme
  })

  return (
    <div className={rootClassName}>
      <div className={styles.actionsContainer}>
        <a
          href={`/favorites?item_id=${item.id}`}
          onClick={onAddToFavourites}
          title="Add to Favorites"
          rel="nofollow"
          className={favoriteClassNames}
        >
          <FavoriteIcon
            className={styles.icon}
            style={{ verticalAlign: '' }}
            title="Add to Favorites"
          />
        </a>
        <a
          href={`/bookmarks/widget?item_id=${item.id}`}
          onClick={event => onAddToCollections(event)}
          title="Add to Collection"
          rel="nofollow"
          className={bookmarkClassNames}
        >
          <FolderOpenIcon
            className={styles.icon}
            style={{ verticalAlign: '' }}
            title="Add to Collection"
          />
        </a>
        <a
          className={cartClassNames}
          onClick={onAddToCart}
          href={`/cart/configure_before_adding/${item.id}`}
          rel="nofollow"
          title="Add to Cart"
        >
          <CartIcon
            className={styles.icon}
            style={{ verticalAlign: '' }}
            title="Add to Cart"
          />
        </a>
      </div>
    </div>
  )
}

export default ItemActions
